import { useRoute, isWechatCallback } from "./router";
import { SiteHeader } from "./components/SiteHeader";
import { ComplianceFooter } from "./components/ComplianceFooter";
import { HomePage } from "./pages/HomePage";
import { PaipanPage } from "./pages/PaipanPage";
import { RecordsPage } from "./pages/RecordsPage";
import { LegalPage } from "./pages/LegalPage";
import { PlaceholderPage } from "./pages/PlaceholderPage";
import { AuthPage } from "./pages/AuthPage";
import { FamousPage } from "./pages/FamousPage";
import { FamousDetailPage } from "./pages/FamousDetailPage";
import { HepanPage } from "./pages/HepanPage";
import { StudyPage, StudyArticlePage } from "./pages/StudyPage";
import { VipPage } from "./pages/VipPage";
import { AdminPage } from "./pages/AdminPage";
import { WechatCallbackPage } from "./pages/WechatCallbackPage";
import { ProfilePage } from "./pages/ProfilePage";
import { findLegalPage } from "./data/legal";

export default function App() {
  const [route, navigate] = useRoute();

  // 微信扫码回来时 code/state 在 query 串里、hash 为空，需在路由之前拦截
  if (isWechatCallback()) {
    return (
      <div className="app-shell">
        <SiteHeader route="auth" onNavigate={navigate} />
        <WechatCallbackPage onNavigate={navigate} />
        <ComplianceFooter onNavigate={navigate} />
      </div>
    );
  }

  return (
    <div className="app-shell">
      <SiteHeader route={route} onNavigate={navigate} />
      {renderRoute(route, navigate)}
      <ComplianceFooter onNavigate={navigate} />
    </div>
  );
}

function renderRoute(route: string, navigate: (next: string) => void) {
  const legal = findLegalPage(route);
  if (legal) return <LegalPage page={legal} />;

  // 名人详情：/famous/<slug> —— 每个历史人物独立可收录页
  if (route.startsWith("famous/")) {
    const slug = route.slice("famous/".length);
    return <FamousDetailPage slug={slug} onNavigate={navigate} />;
  }

  // 古籍课堂文章详情：/study/<slug>
  if (route.startsWith("study/")) {
    const slug = route.slice("study/".length);
    return <StudyArticlePage slug={slug} onNavigate={navigate} />;
  }

  switch (route) {
    case "home":
      return <HomePage onNavigate={navigate} />;
    case "paipan":
      return <PaipanPage />;
    case "records":
      return <RecordsPage onNavigate={navigate} />;
    case "auth":
      return <AuthPage onNavigate={navigate} />;
    case "auth/wechat":
      return <WechatCallbackPage onNavigate={navigate} />;
    case "profile":
      return <ProfilePage onNavigate={navigate} />;
    case "famous":
      return <FamousPage onNavigate={navigate} />;
    case "hepan":
      return <HepanPage onNavigate={navigate} />;
    case "study":
      return <StudyPage onNavigate={navigate} />;
    case "vip":
      return <VipPage onNavigate={navigate} />;
    case "admin":
      return <AdminPage />;
    default:
      return <PlaceholderPage title="页面不存在" />;
  }
}
